import { useQuery } from '@apollo/client';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { Panel } from '~/components/common/Panel';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { StudyList } from '~/components/upload/study/study-list';
import { useSortFilter } from '~/hooks/data';
import { uploadStudyCreateRoute } from '~/paths';
import { toSortableStudy } from '~/routes/upload/model/__uploadModelsPage/studies';
import { useUploadOutcropUpdateRouteOutletContext } from '~/routes/upload/model/outcrop/$outcropId';

const UPLOAD_OUTCROP_UPDATE_STUDIES_PAGE = graphql(`
  query UploadOutcropUpdateStudiesPage($id: ID!) {
    outcropGet(id: $id) {
      id
      studies {
        ...uploadStudyListParts
      }
    }
  }
`);

export default function UpdateOutcropStudiesPage() {
  return (
    <ApolloProviderV4>
      <UpdateOutcropStudiesPageInner />
    </ApolloProviderV4>
  );
}

function UpdateOutcropStudiesPageInner() {
  const ctx = useUploadOutcropUpdateRouteOutletContext();
  const outcropId = ctx.outcrop.id;

  const { data, loading } = useQuery(UPLOAD_OUTCROP_UPDATE_STUDIES_PAGE, {
    variables: { id: outcropId },
  });

  const studyList = data?.outcropGet?.studies ?? [];
  const sortableStudies = studyList.map(toSortableStudy);

  const { items, sortIndicatorProps, filterSearchProps } = useSortFilter(
    sortableStudies,
    'id',
    'searchableText',
    'uploadStudyList',
  );

  return (
    <Panel>
      <Panel.Heading className="flex justify-between items-center">
        <Panel.Title>Studies</Panel.Title>
        <Link
          to={`${uploadStudyCreateRoute()}?outcropId=${outcropId}`}
          className="btn btn-primary btn-xs gap-1"
        >
          <FontAwesomeIcon icon={faPlus} /> Create Study
        </Link>
      </Panel.Heading>

      <Panel.Body>
        <SpinnerPlaceholder show={loading} />
        {!loading && (
          <StudyList
            studies={items}
            sortIndicatorProps={sortIndicatorProps}
            filterSearchProps={filterSearchProps}
          />
        )}
      </Panel.Body>
    </Panel>
  );
}
